let idQR, idPoliza;
const paso1Url = "https://eocfflfoq4dbsfq.m.pipedream.net";
const paso2Url = "https://eojqlb86nip85wk.m.pipedream.net";
const paso3Url = "https://eovhibi96fzo8tu.m.pipedream.net";
const paso4Url = "https://eo3tppfie5xltcu.m.pipedream.net";
const paso5Url = "https://eoja2dvoqaohpp4.m.pipedream.net";

let toIndex, $formVidaNatura;

document.addEventListener('DOMContentLoaded', function () {
  // Wait until the form is done initializing
  CF.ready(function () {
    // Se define el formulario Poner el código del FORM y el nombre
    $formVidaNatura = document.querySelector('form[data-cf-form="mMt7n1"]');
    let url;
    let mensajeProcesandoElement, mensajeErrorElement;

    $formVidaNatura.addEventListener('cf:field_changed', function (event) {
      var fieldId = event.detail.fieldId;
      var columnKey = event.detail.columnKey;
      var value = event.detail.value;

      if (columnKey == 'porcentaje_benef_n') {
        var sum = 0;
        $formVidaNatura.cfForm.getFieldValue('beneficiarios').forEach(function (item) {
          if (!isNaN(item.porcentaje_benef_n)) {
            sum += parseFloat(item.porcentaje_benef_n);
          }
        });
        $formVidaNatura.cfForm.setFieldValue('porcentaje_total_benef', sum);
      }
      if (columnKey.startsWith("opcion_") && value != "") {        
        desmarcar(columnKey);
      }
    });

    // Listener de cambio de Step (si aún necesitas este código para otras validaciones)
    $formVidaNatura.addEventListener('cf:step_changed', function (event) {
      let formId = event.detail.formId;
      let fromIndex = event.detail.fromIndex;
      toIndex = event.detail.toIndex;

      // Código para el envío de de trama a Envio de OTP, a Pipedream Etapa 6 Reviso los datos a 7 Confirma OTP
      if (fromIndex === 2 && toIndex === 3) {
        let primaNatura, codigoPlan;

        // Defino el valor de la prima en base a los booleanos de radio-check
        if ($formVidaNatura.cfForm.getFieldValue('opcion_1')) {
          primaNatura = "280";
          codigoPlan = "PVM001"; //codigo por entregar por LBC //
        } else if ($formVidaNatura.cfForm.getFieldValue('opcion_2')) {
          primaNatura = "280";
          codigoPlan = "PVM002"; //codigo por entregar por LBC //
        } else if ($formVidaNatura.cfForm.getFieldValue('opcion_3')) {
          primaNatura = "148,5";
          codigoPlan = "PVM003"; //codigo por entregar por LBC //
        } else if ($formVidaNatura.cfForm.getFieldValue('opcion_4')) {
          primaNatura = "148,5";
          codigoPlan = "PVM004"; //codigo por entregar por LBC //
        } else {
          console.log('No se registró ninguna opción');
        }

        let data = {
          'primer_nombre': $formVidaNatura.cfForm.getFieldValue('primer_nombre'),
          'segundo_nombre': $formVidaNatura.cfForm.getFieldValue('segundo_nombre'),
          'apellido_paterno': $formVidaNatura.cfForm.getFieldValue('apellido_paterno'),
          'apellido_materno': $formVidaNatura.cfForm.getFieldValue('apellido_materno'),
          'apellido_casada': "",
          'phone': $formVidaNatura.cfForm.getFieldValue('phone'),
          'correo_facturacion': $formVidaNatura.cfForm.getFieldValue('correo_facturacion'),
          'tipo_documento': $formVidaNatura.cfForm.getFieldValue('tipo_documento'),
          'nro_documento_facturacion': $formVidaNatura.cfForm.getFieldValue('nro_documento_facturacion'),
          'extension': $formVidaNatura.cfForm.getFieldValue('extension'),
          'complemento': $formVidaNatura.cfForm.getFieldValue('complemento'),
          'fecha_de_nacimiento': $formVidaNatura.cfForm.getFieldValue('fecha_de_nacimiento'),
          'lugar_de_nacimiento': $formVidaNatura.cfForm.getFieldValue('lugar_de_nacimiento'),
          'nacionalidad': $formVidaNatura.cfForm.getFieldValue('nacionalidad'),
          'estado_civil': $formVidaNatura.cfForm.getFieldValue('estado_civil'),
          'genero': $formVidaNatura.cfForm.getFieldValue('genero'),
          'profesion': "",
          'ocupacion_principal': $formVidaNatura.cfForm.getFieldValue('ocupacion_principal'),
          'pais': $formVidaNatura.cfForm.getFieldValue('pais'),
          'departamento': $formVidaNatura.cfForm.getFieldValue('default_address.province'),
          'ciudad': $formVidaNatura.cfForm.getFieldValue('default_address.city'),
          'zona': $formVidaNatura.cfForm.getFieldValue('zona'),
          'calle': $formVidaNatura.cfForm.getFieldValue('default_address.address1'),
          'numero_de_casa': $formVidaNatura.cfForm.getFieldValue('numero_de_casa'),
          'barrio': $formVidaNatura.cfForm.getFieldValue('barrio'),
          'referencia': $formVidaNatura.cfForm.getFieldValue('referencia'),
          'beneficiarios': $formVidaNatura.cfForm.getFieldValue('beneficiarios')
        };
        let submissionData = { ...data };

        // Ensure submissionData is not null
        if (submissionData) {
          // Sending OTP to Pipedream endpoint
          const requestOptions = {
            method: "POST",
            body: JSON.stringify(submissionData),
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: "follow"
          };
          fetch(paso1Url, requestOptions) //endpoint correspondiente a 01 Envio OTP Natura en pipedream
            .then((response) => response.text())
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        } else {
          console.error("No data found to send");
        }

        // Listener para el botón "Verificar OTP"
        document.getElementById('verificarOTP').addEventListener('click', function () {
          document.getElementById('verificarOTP').style.display = 'none';
          document.getElementById('verificarOTP-loading').style.display = 'inline-flex';

          const otpFieldValue = $formVidaNatura.cfForm.getFieldValue('otp_vida_natura');
          const nroDocumentoFacturacion = $formVidaNatura.cfForm.getFieldValue('nro_documento_facturacion');
          const phone = $formVidaNatura.cfForm.getFieldValue('phone');
          const correoFacturacion = $formVidaNatura.cfForm.getFieldValue('correo_facturacion');

          const data = {
            otpIngresado: otpFieldValue,
            nro_documento_facturacion: nroDocumentoFacturacion,
            phone: phone,
            correo_facturacion: correoFacturacion
          };

          const requestOptions = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: "follow"
          };

          fetch(paso2Url, requestOptions) //endopoint de validacion de OTP Natura
            .then((response) => {
              document.getElementById('verificarOTP').style.display = 'inline-flex';
              document.getElementById('verificarOTP-loading').style.display = 'none';
              return response.json(); // Asegurarse de parsear el JSON
            })
            .then((result) => {
              if (result.respuesta === 'Verificado') {
                CF.customer.set('otp_verificado', true);
                $formVidaNatura.cfForm.setFieldValue('otp_verificado', true); // Establecer otp_verificado en true
                document.getElementById('div-mensaje-otp').style.display = 'block'
                document.getElementById('div-mensaje-otp').classList.add('mensaje-exito-otp');
                document.getElementById('div-mensaje-otp').classList.remove('mensaje-error-otp');
                document.getElementById('mensaje-respuesta-otp').innerText = "OTP Verificado exitosamente";
              } else {
                document.getElementById('div-mensaje-otp').style.display = 'block'
                document.getElementById('mensaje-respuesta-otp').innerText = "OTP Inválido";
                document.getElementById('div-mensaje-otp').classList.add('mensaje-error-otp');
                document.getElementById('div-mensaje-otp').classList.remove('mensaje-exito-otp');
              }
            })
            .catch((error) => {
              console.error('Error en la validación OTP:', error);
              document.getElementById('div-mensaje-otp').style.display = 'block'
              document.getElementById('div-mensaje-otp').classList.add('mensaje-error-otp');
              document.getElementById('div-mensaje-otp').classList.remove('mensaje-exito-otp');
              document.getElementById('mensaje-respuesta-otp').innerText = "Servicio no disponible";
            });
        });
      }
      // Envío final de datos para QR, Trama, Nota de Cobertura y QR
      else if (fromIndex == 3 && toIndex == 4) {

        CF.customer.set('paso_final', true);
        $formVidaNatura.cfForm.setFieldValue('paso_final', true);
        mensajeProcesandoElement = document.querySelector('div.cf-field.mensaje-procesando');
        mensajeErrorElement = document.querySelector('div.cf-field.mensaje-error-pago');
        mensajeProcesandoElementBase = document.querySelector('div.cf-field-container.mensaje-procesando');
        mensajeErrorElementBase = document.querySelector('div.cf-field-container.mensaje-error-pago');

        let formId = event.detail.formId;
        let primaNatura, codigoPlan;

        // Defino el valor de la prima en base a los booleanos de radio-check
        if ($formVidaNatura.cfForm.getFieldValue('opcion_1')) {
          primaNatura = "280";
          codigoPlan = "PVM001"; //codigo por entregar por LBC //
        } else if ($formVidaNatura.cfForm.getFieldValue('opcion_2')) {
          primaNatura = "280";
          codigoPlan = "PVM002"; //codigo por entregar por LBC //
        } else if ($formVidaNatura.cfForm.getFieldValue('opcion_3')) {
          primaNatura = "148,50";
          codigoPlan = "PVM003"; //codigo por entregar por LBC //
        } else if ($formVidaNatura.cfForm.getFieldValue('opcion_4')) {
          primaNatura = "148,50";
          codigoPlan = "PVM004"; //codigo por entregar por LBC //
        } else {
          console.log('No se registró ninguna opción');
        }
        let data = {
          'primer_nombre': $formVidaNatura.cfForm.getFieldValue('primer_nombre'),
          'segundo_nombre': $formVidaNatura.cfForm.getFieldValue('segundo_nombre'),
          'apellido_paterno': $formVidaNatura.cfForm.getFieldValue('apellido_paterno'),
          'apellido_materno': $formVidaNatura.cfForm.getFieldValue('apellido_materno'),
          'apellido_casada': "",
          'phone': $formVidaNatura.cfForm.getFieldValue('phone'),
          'correo_facturacion': $formVidaNatura.cfForm.getFieldValue('correo_facturacion'),
          'tipo_documento': $formVidaNatura.cfForm.getFieldValue('tipo_documento'),
          'nro_documento_facturacion': $formVidaNatura.cfForm.getFieldValue('nro_documento_facturacion'),
          'extension': $formVidaNatura.cfForm.getFieldValue('extension'),
          'complemento': $formVidaNatura.cfForm.getFieldValue('complemento'),
          'fecha_de_nacimiento': $formVidaNatura.cfForm.getFieldValue('fecha_de_nacimiento'),
          'lugar_de_nacimiento': $formVidaNatura.cfForm.getFieldValue('nacionalidad'),
          'nacionalidad': $formVidaNatura.cfForm.getFieldValue('nacionalidad'),
          'estado_civil': $formVidaNatura.cfForm.getFieldValue('estado_civil'),
          'genero': $formVidaNatura.cfForm.getFieldValue('genero'),
          'profesion': "",
          'ocupacion_principal': $formVidaNatura.cfForm.getFieldValue('ocupacion_principal'),
          'pais': $formVidaNatura.cfForm.getFieldValue('pais'),
          'departamento': $formVidaNatura.cfForm.getFieldValue('default_address.province'),
          'ciudad': $formVidaNatura.cfForm.getFieldValue('default_address.city'),
          'zona': $formVidaNatura.cfForm.getFieldValue('zona'),
          'calle': $formVidaNatura.cfForm.getFieldValue('default_address.address1'),
          'numero_de_casa': $formVidaNatura.cfForm.getFieldValue('numero_de_casa'),
          'barrio': $formVidaNatura.cfForm.getFieldValue('barrio'),
          'referencia': $formVidaNatura.cfForm.getFieldValue('referencia'),
          'beneficiarios': $formVidaNatura.cfForm.getFieldValue('beneficiarios'),
          'acuerdo_final': $formVidaNatura.cfForm.getFieldValue('acuerdo_final'),
          'acepto_terminos_y_condiciones': $formVidaNatura.cfForm.getFieldValue('acepto_terminos_y_condiciones'),
          'consentimiento_de_recepcion': $formVidaNatura.cfForm.getFieldValue('consentimiento_de_recepcion'),
          'prima': primaNatura,
          'codigoPlan': codigoPlan,
        };
        let submissionData = { ...data };

        //Evento descargar imagen QR 
        document.getElementById('descargar-QR').addEventListener('click', function () {
          // Obtener el elemento de la imagen
          const imgElement = document.getElementById('base64imageQR');
          // Obtener la URL de la imagen (base64)
          const imgBase64 = imgElement.src;
          // Crear un enlace temporal
          const link = document.createElement('a');
          link.href = imgBase64;
          // Establecer el nombre del archivo que se descargará
          link.download = 'PagoSeguroQR.png';
          // Añadir el enlace temporal al documento
          document.body.appendChild(link);
          // Hacer clic en el enlace para descargar la imagen
          link.click();
          // Eliminar el enlace temporal del documento
          document.body.removeChild(link);
        });
        //

        if (submissionData) {

          const requestOptions = {
            method: "POST",
            body: JSON.stringify(submissionData),
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: "follow"
          };
          fetch(paso3Url, requestOptions)
            .then((response) => response.json())
            .then(data => {
              let base64imageElement = document.getElementById('base64imageQR');
              if (base64imageElement) {
                base64imageElement.src = 'data:image/png;base64,' + data.image;
                base64imageElement.style.display = 'block';
                document.getElementById('descargar-QR').style.display = 'block';
                document.querySelector('div.cf-field.texto-generacion-qr').classList.add('oculto');
              } else {
                console.error('Element base64imageQR not found');
              }

              let loadingQRElement = document.getElementById('loadingQR');
              if (loadingQRElement) {
                loadingQRElement.style.display = 'none';
              } else {
                console.error('Element loadingQR not found');
              }

              let yahepagadoElement = document.getElementById('yahepagado');
              if (yahepagadoElement) {
                yahepagadoElement.style.display = 'block';
              } else {
                console.error('Element yahepagado not found');
              }

              idQR = data.id;
              idPoliza = data.idPoliza;
            })
            .catch(error => {
              console.log('Error fetching the image:', error);
            });
        }

        let button = document.getElementById('yahepagado');

        // $formVidaNatura.cfForm.beforeSave(function () {
        //   return new Promise((resolve, reject) => {
        //     // window.open(url, '_blank');
        //     // window.location.reload();

        //     // reject(true); to reject
        //   });
        // });

        button.addEventListener('click', function () {
          button.classList.add('no-click');
          mensajeProcesandoElement.classList.remove("mensaje-procesando");
          mensajeProcesandoElementBase.classList.remove("mensaje-procesando");
          mensajeErrorElement.classList.add('mensaje-error-pago');
          mensajeErrorElementBase.classList.add('mensaje-error-pago');
          if (submissionData) {
            // Añadir idQR y idPoliza a submissionData
            let finalSubmissionData = {
              ...submissionData,
              idQR: idQR,
              idPoliza: idPoliza
            };

            const requestOptions = {
              method: "POST",
              body: JSON.stringify(finalSubmissionData),
              headers: {
                'Content-Type': 'application/json'
              },
              redirect: "follow"
            };

            fetch(paso4Url, requestOptions) //endpoint de pipedream 04 Aviso Pago QR Natura
              .then(response => response.json())
              .then(result => {
                document.getElementById('yahepagado').classList.remove('no-click');
                debugger;
                if (result && result.mensaje) {
                  if (result.mensaje === "No pagado") {
                    document.getElementById('yahepagado').classList.remove('no-click');
                    mensajeProcesandoElement.classList.add('mensaje-procesando');
                    mensajeErrorElement.classList.remove('mensaje-error-pago');
                    mensajeProcesandoElementBase.classList.add('mensaje-procesando');
                    mensajeErrorElementBase.classList.remove('mensaje-error-pago');
                  }
                  else if (result.mensaje === 'Pagado') {
                    // url = result.url;
                    // CF.customer.set('paso_final', false);
                    // $formVidaNatura.cfForm.setFieldValue('paso_final', false);
                    CF.customer.set('ya_he_pagado', true);
                    $formVidaNatura.cfForm.setFieldValue('ya_he_pagado', true);
                    mensajeProcesandoElement.classList.add('mensaje-procesando');
                    mensajeErrorElement.classList.add('mensaje-error-pago');
                    mensajeProcesandoElementBase.classList.add('mensaje-procesando');
                    mensajeErrorElementBase.classList.add('mensaje-error-pago');
                    document.getElementById('base64imageQR').style.display = 'none';
                    document.getElementById('descargar-QR').classList.add('oculto');
                    document.getElementById('yahepagado').classList.add('oculto');

                    let verificado = document.querySelector('div.cf-field.pago-verificado');
                    let verificadoBase = document.querySelector('div.cf-field-container.pago-verificado');
                    verificado.classList.remove('pago-verificado');
                    verificadoBase.classList.remove('pago-verificado');

                    let formActionsDiv = document.querySelector('div.cf-form-actions');

                    let observer = new MutationObserver((mutationsList) => {
                      for (let mutation of mutationsList) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'data-empty') {
                          let isEmpty = formActionsDiv.getAttribute('data-empty') === 'true';
                          if (!isEmpty) {
                            let botonAtras = document.querySelector('button[class="cf-prev-step cf-button btn button"]')
                            if (botonAtras) {
                              botonAtras.style.display = 'none';
                            }
                          }
                        }
                      }
                    });

                    observer.observe(formActionsDiv, { attributes: true });

                    const newOptions = {
                      method: "POST",
                      body: JSON.stringify(result),
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      redirect: "follow"
                    };
                    fetch(paso5Url, newOptions)
                      .then((response) => response.json())
                      .then((result) => {
                        if (isValidUrl(result.url)) {
                          url = result.url
                          localStorage.removeItem('cf:guest_data');
                          window.location.href = url;
                          console.log(url);
                        } else {
                          console.error('Error', result);
                        }
                      })
                      .catch((error) => console.error(error));
                  }
                }
                else {
                  console.error('Error', result);
                }
              })
              .catch(error => {
                document.getElementById('yahepagado').classList.remove('no-click');
                mensajeProcesandoElement.classList.add('mensaje-procesando');
                mensajeErrorElement.classList.remove('mensaje-error-pago');
                mensajeProcesandoElementBase.classList.add('mensaje-procesando');
                mensajeErrorElementBase.classList.remove('mensaje-error-pago');
                console.error('Error:', error);
              }
              );
          }
        });
      }
    });
  });
});

// Helper function to validate URL
function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

function desmarcar(opcion) {
  debugger;
  let opciones = ["opcion_1", "opcion_2", "opcion_3", "opcion_4"];
  for (const item of opciones) {
    if (item != opcion) {
      $formVidaNatura.cfForm.setFieldValue(item, "");
    }
  }
}